import { Box } from '@mui/material';

export const LABOURROOM = () => {
  return <Box sx={{ flex: 1 }}></Box>;
};
